module.exports = "app.service(\"Contact\",[\"Resty\",function(Resty){return Resty(\"contacts\",function(klass){klass.tableList=klass.page;});}]);"